import { render, staticRenderFns } from "./BackToMypPageTopButton.vue?vue&type=template&id=76fbf739&"
import script from "./BackToMypPageTopButton.vue?vue&type=script&lang=ts&"
export * from "./BackToMypPageTopButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports